import { render } from "./LabComp.vue?vue&type=template&id=63f98f76&scoped=true"
import script from "./LabComp.vue?vue&type=script&lang=js"
export * from "./LabComp.vue?vue&type=script&lang=js"

import "./LabComp.vue?vue&type=style&index=0&id=63f98f76&scoped=true&lang=scss"

import exportComponent from "F:\\vue\\raven\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f98f76"]])

export default __exports__